module.exports = __webpack_public_path__ + "img/map-circle3.22de183c.svg";